import { render, staticRenderFns } from "./viewsend.vue?vue&type=template&id=7b126e08&scoped=true&"
import script from "./viewsend.vue?vue&type=script&lang=js&"
export * from "./viewsend.vue?vue&type=script&lang=js&"
import style0 from "./viewsend.vue?vue&type=style&index=0&id=7b126e08&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7b126e08",
  null
  
)

export default component.exports